/* global modForm */
import { getTcpaElementContent, appendFormInput } from '../../../helpers';

export function updateConsentHiddenFields() {
	if (modForm.opts.fetchAndFormatConsentListings || modForm.opts.sendConsentCaptureTcpaToLead) {
		const tcpaCopyField = modForm.opts.tcpaCopy && modForm.opts.tcpaCopy.length ? Array.from(modForm.opts.tcpaCopy).map(tcpa => getTcpaElementContent(tcpa).trim().replace(/(<([^>]+)>)/ig, '').replace(/\n/g, '').replace(/[\u00A0]+/g, '')) : '';
		const fieldsToBeUpdated = {
			tcpaText: tcpaCopyField,
			HomePhoneConsentLanguage: tcpaCopyField
		};
		Object.keys(fieldsToBeUpdated).forEach((key) => {
			appendFormInput(key, fieldsToBeUpdated[key]);
		});
	}
}
